(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityMenuBarButtons', drvEntityMenuBarButtons);

    drvEntityMenuBarButtons.$inject = [];

    /**
     * @ngdoc directive
     * @name drvEntityMenuBarButtons
     * 
     * @description
     * Creates a list of entity menu bar buttons. The supplied functions will be invoked when the appropriate button is clicked.
     *
     * # Scope Params
     * {function} onEmail - Function called when 'Email' is clicked.
     * {function} onFile - Function called when 'File' is clicked.
     * {function} onMerge - Function called when 'Merge' is clicked.
     * {function} onWorkflow - Function called when 'Workflow' is clicked.
     * {function} onSms - Function called when 'SMS' is clicked.
     * {function} onTask - Function called when 'Task' is clicked.
     * {function} onNote - Function called when 'Note' is clicked.
     * {function} onCopy - Function called when 'Copy' is clicked.
     * {function} onDelete - Function called when 'Delete' is clicked.
     * {function} onExport - Function called when 'Export' is clicked.
     * {function} onImport - Function called when 'Import' is clicked.
     * {object} entityTemplate - Details of the entity template. If supplied the view entity template button will be shown. Clicking the entity template button will redirect to the edit entity template view.
     */
    function drvEntityMenuBarButtons() {
        var directive = {
            templateUrl: 'app/entity/entity-menu-bar-buttons.tmpl.html',
            scope: {
                onEmail: '&',
                onFile: '&',
                onMerge: '&',
                onWorkflow: '&',
                onSms: '&',
                onTask: '&',
                onNote: '&',
                onCopy: '&',
                onDelete: '&',
                onExport: '&',
                onImport: '&',
                entityTemplate: '<?'
            },
            controller: drvEntityMenuBarButtonsCtrl
        };

        drvEntityMenuBarButtonsCtrl.$inject = ['$location', '$scope', 'NavigationAidService'];

        return directive;

        function drvEntityMenuBarButtonsCtrl($location, $scope, NavigationAidService) {
            $scope.onEntityTemplate = onEntityTemplate;

            /*
             * Redirect to the entity template edit view
             */
            function onEntityTemplate() {
                var url = '/entitytemplates/' + $scope.entityTemplate.Id;

                if (url === NavigationAidService.getPreviousPath()) {
                    // if the previous path is where you want to go, then simply go back
                    NavigationAidService.goBack();
                }
                else {
                    $location.url(url);
                }
            }
        }
    }
})();